import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import swal from 'sweetalert2';

interface ModalShareProps {
  show: boolean;
  handleClose: () => void;
  title?: string;
  username?: string;
  module?: string;
}

const ModalErrorComponent: React.FC<ModalShareProps> = ({
  show,
  handleClose,
  title,
  username,
  module,
}) => {
  const [comment, setComment] = useState('');
  const [isCommentFocused, setIsCommentFocused] = useState(false);

  const handleInputChange =
    (setter: React.Dispatch<React.SetStateAction<string>>) =>
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setter(event.target.value);
    };

  const handleFocus =
    (setter: React.Dispatch<React.SetStateAction<boolean>>) => () => {
      setter(true);
    };

  const handleBlur =
    (setter: React.Dispatch<React.SetStateAction<boolean>>, value: string) =>
    () => {
      setter(value !== '');
    };

  const isFormValid = comment !== '';

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const data = {
      Collection: module,
      Module: title,
      User: username,
      Report: comment,
    };

    // Resetear los campos

    setIsCommentFocused(false);

    try {
      const response = await fetch(
        'https://cms.siticsoftware.com/api/reports',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${process.env.REACT_APP_STRAPI_TOKEN}`,
          },
          body: JSON.stringify({ data }), // Envolviendo `data` dentro de `{ data }` como Strapi espera
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json(); // Obtener detalles del error
        throw new Error(`Error al enviar la reseña: ${errorResponse.message}`);
      }

      // console.log('Reporte enviado exitosamente:', data);
      setComment('');
      setIsCommentFocused(false); // Deshabilitar los botones después de enviar la reseña
      // Mostrar alerta de éxito
      handleClose();
      swal.fire({
        title: 'Correo enviado',
        text: 'Error reportado con éxito',
        icon: 'success',
        confirmButtonText: 'Aceptar',
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  // console.log(title, username, module)

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Reportar error
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <p className="text-gray600">
              Si identificó un error en el contenido o algo fuera de lugar,
              háganoslo saber para solucionarlo a la brevedad.
            </p>
          </div>

          <div className="form-row from--control-wrapp">
            <textarea
              className="form-control"
              placeholder={
                isCommentFocused || comment !== '' ? '' : 'Comentario'
              }
              value={comment}
              onChange={handleInputChange(setComment)}
              onFocus={handleFocus(setIsCommentFocused)}
              onBlur={handleBlur(setIsCommentFocused, comment)}
            />
            <label>Comentario</label>
          </div>
          <div className="form-row row--last d-flex justify-content-center">
            <button
              type="submit"
              className="btn btn--type1"
              disabled={!isFormValid}
            >
              Enviar <i className="icon icon--arrow-circle"></i>
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalErrorComponent;
